var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-app", [
    _c(
      "div",
      {
        class: [
          _vm.$vuetify.breakpoint.xs
            ? "gradient-blue flex-col items-center"
            : "bg-white",
          "min-h-screen flex sm:justify-center overflow-hidden",
        ],
      },
      [
        _c(
          "div",
          { staticClass: "my-12" },
          [
            _vm.$vuetify.breakpoint.xs
              ? _c("v-img", {
                  attrs: {
                    src: "/Musicologie-White-Wordmark.png",
                    "max-width": "200",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "max-w-3xl w-full px-6",
              _vm.$vuetify.breakpoint.xs ? null : "upper-third",
            ],
          },
          [
            _c(
              "div",
              {
                class: [
                  "w-full bg-white custom-shadow soli-round overflow-hidden",
                ],
              },
              [
                _c(
                  "v-container",
                  { staticClass: "ma-0 flex justify-center" },
                  [
                    _c(
                      "v-row",
                      { class: _vm.$vuetify.breakpoint.xs ? null : "tall" },
                      [
                        _vm.$vuetify.breakpoint.smAndUp
                          ? _c(
                              "v-col",
                              {
                                staticClass:
                                  "col-6 gradient-blue flex align-center justify-center",
                                staticStyle: { "background-color": "#228cbd" },
                              },
                              [
                                _c("v-img", {
                                  attrs: {
                                    src: "/Musicologie-White-Wordmark.png",
                                    "max-width": "275",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass: "xs:col-12 sm:col-6 align-self-center",
                          },
                          [
                            _c("v-card-title", { staticClass: "soli-grey" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    `${
                                      _vm.hasErrors
                                        ? " Uh-oh"
                                        : "Confirm Password"
                                    }`
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-subtitle",
                              { staticClass: "error--text" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.form.errors.password) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-container",
                                  [
                                    _c("SoliText", {
                                      ref: "password",
                                      attrs: {
                                        name: "password",
                                        label: "",
                                        required: "",
                                        password: true,
                                        show: _vm.show,
                                      },
                                      on: {
                                        append: function ($event) {
                                          _vm.show = !_vm.show
                                        },
                                      },
                                      model: {
                                        value: _vm.form.password,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "password", $$v)
                                        },
                                        expression: "form.password",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "justify-end flex align-center",
                                          },
                                          [
                                            _c("SoliBtn", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                href: "/dashboard",
                                                gradient: "gradient-blue",
                                                text: "Lobby",
                                                icon: null,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("SoliBtn", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                gradient: "gradient-orange",
                                                text: "Continue",
                                                icon: null,
                                                loading: _vm.form.processing,
                                                type: "submit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }